export const apiCreate = (): string => '/commercial/advertisements/'

export const apiList = (id?: string): string =>
  !id ? '/commercial/advertisements/' : `/commercial/advertisements/view/${id}`

export const apiListPagination = (): string =>
  '/commercial/advertisements/pagination'

export const apiUpdate = (id: string): string =>
  `/commercial/advertisements/update/${id}`

export const apiDelete = (id: string): string =>
  `/commercial/advertisements/${id}`
